"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveLinkWidget = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Declarative_1 = require("../utils/Declarative");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var underline = { textDecoration: 'underline' };
var interactiveStyles = {
    active: underline,
    focus: underline,
    hover: underline,
};
/**
 * The styling of this widget is not extensible for interactive states and does not match defined Tableau styles.
 *
 * @deprecated use `TextLinkWidget`
 */
var InteractiveLinkWidget = /** @class */ (function (_super) {
    tslib_1.__extends(InteractiveLinkWidget, _super);
    function InteractiveLinkWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            if (_this.props.onClick) {
                _this.props.onClick();
            }
        };
        return _this;
    }
    InteractiveLinkWidget.prototype.render = function () {
        var anchorProps = {
            'data-tb-test-id': Declarative_1.makeTestId(this.props.testId, 'InteractiveLink'),
            href: this.props.href || '#',
            onClick: this.handleClick,
            style: tslib_1.__assign(tslib_1.__assign({}, this.props.style), { textDecoration: 'none' }),
        };
        return (React.createElement(InteractiveDom_1.InteractiveDomWrapper, { interactiveStyles: interactiveStyles },
            React.createElement("a", tslib_1.__assign({}, anchorProps), this.props.text)));
    };
    return InteractiveLinkWidget;
}(React.PureComponent));
exports.InteractiveLinkWidget = InteractiveLinkWidget;
//# sourceMappingURL=InteractiveLinkWidget.js.map